<template>
  <component v-if="stepSelected" :is="componentStep" />
</template>

<script>

export default {
  name: 'step',
  props: {
    stepSelected: {
      type: Object,
    },
  },
  computed: {
    componentStep() {
      const { component } = this.stepSelected;
      const path = './';
      return () => import(`${path}${component}.vue`);
    },
  },
};
</script>
